"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var EmailApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(EmailApi, _BasicProviderApi);

  /**
   * Represents an Email Api.
   * @constructor
   */
  function EmailApi(_ref) {
    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId,
        httpGatewayUrl = _ref.httpGatewayUrl,
        sendWSMessage = _ref.sendWSMessage;
    (0, _classCallCheck2.default)(this, EmailApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmailApi).call(this, {
      userTokenFactory: userTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId,
      httpGatewayUrl: httpGatewayUrl,
      sendWSMessage: sendWSMessage
    }));
  }
  /**
   * @param {String} param0.path provider url
   */


  (0, _createClass2.default)(EmailApi, [{
    key: "getEmailSettings",
    value: function () {
      var _getEmailSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(path) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._callApi({
                  method: 'get',
                  path: path,
                  errorName: 'EmailError_getEmailSettings'
                });

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEmailSettings(_x) {
        return _getEmailSettings.apply(this, arguments);
      }

      return getEmailSettings;
    }()
    /**
     * @param {String} param0.path provider url
     * @param {Object} param0.payload request params
     */

  }, {
    key: "getEmailIdentifiers",
    value: function () {
      var _getEmailIdentifiers = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(path, payload) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._callApi({
                  method: 'post',
                  path: path,
                  payload: payload,
                  errorName: 'EmailError_getEmailIdentifiers'
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getEmailIdentifiers(_x2, _x3) {
        return _getEmailIdentifiers.apply(this, arguments);
      }

      return getEmailIdentifiers;
    }()
    /**
     * @param {String} param0.path provider url
     * @param {Object} param0.payload request params
     */

  }, {
    key: "registerBotmailAccount",
    value: function () {
      var _registerBotmailAccount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(path, payload) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._callApi({
                  method: 'post',
                  path: path,
                  payload: payload,
                  errorName: 'EmailError_registerBotmailAccount'
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function registerBotmailAccount(_x4, _x5) {
        return _registerBotmailAccount.apply(this, arguments);
      }

      return registerBotmailAccount;
    }()
    /**
    * @param {String} param0.path provider url
    * @param {Object} param0.payload request params
    */

  }, {
    key: "checkIMAPCredentials",
    value: function () {
      var _checkIMAPCredentials = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(path, payload) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._callApi({
                  method: 'post',
                  path: path,
                  payload: payload,
                  errorName: 'EmailError_checkIMAPCredentials'
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function checkIMAPCredentials(_x6, _x7) {
        return _checkIMAPCredentials.apply(this, arguments);
      }

      return checkIMAPCredentials;
    }()
    /**
     * @param {String} param0.path provider url
     * @param {Object} param0.payload request params
     */

  }, {
    key: "checkSMTPCredentials",
    value: function () {
      var _checkSMTPCredentials = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(path, payload) {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._callApi({
                  method: 'post',
                  path: path,
                  payload: payload,
                  errorName: 'EmailError_checkSMTPCredenntials'
                });

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function checkSMTPCredentials(_x8, _x9) {
        return _checkSMTPCredentials.apply(this, arguments);
      }

      return checkSMTPCredentials;
    }()
    /**
     * @param {String} param0.path provider url
     * @param {Object} param0.payload request params
     */

  }, {
    key: "createIMAPAccount",
    value: function () {
      var _createIMAPAccount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(path, payload) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._callApi({
                  method: 'post',
                  path: path,
                  payload: {
                    accountId: payload.accountId,
                    requestedAccount: payload.requestedAccount
                  },
                  errorName: 'EmailError_createIMAPAccount'
                });

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createIMAPAccount(_x10, _x11) {
        return _createIMAPAccount.apply(this, arguments);
      }

      return createIMAPAccount;
    }()
    /**
     * @param {String} param0.path provider url
     * @param {Object} param0.payload request params
     */

  }, {
    key: "updateIMAPAccount",
    value: function () {
      var _updateIMAPAccount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(path, payload) {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._callApi({
                  method: 'put',
                  path: path,
                  payload: {
                    accountId: payload.accountId,
                    requestedEmail: payload.requestedEmail
                  },
                  errorName: 'EmailError_updateIMAPAccount'
                });

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateIMAPAccount(_x12, _x13) {
        return _updateIMAPAccount.apply(this, arguments);
      }

      return updateIMAPAccount;
    }()
    /**
     * @param {String} param0.path provider url
     * @param {Object} param0.payload request params
     */

  }, {
    key: "deleteEmailAccount",
    value: function () {
      var _deleteEmailAccount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(path, payload) {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._callApi({
                  method: 'delete',
                  path: path,
                  payload: {
                    accountId: payload.accountId,
                    requestedEmail: {
                      id: payload.id,
                      address: payload.address
                    }
                  },
                  errorName: 'EmailError_deleteEmailAccount'
                });

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function deleteEmailAccount(_x14, _x15) {
        return _deleteEmailAccount.apply(this, arguments);
      }

      return deleteEmailAccount;
    }()
  }]);
  return EmailApi;
}(_basic_provider.default);

var _default = EmailApi;
exports.default = _default;